import { useTableStoreValue } from '../TableContext';

export const useIsResizingColumn = () => {
  const [table] = useTableStoreValue('table');
  return table.getState().columnSizingInfo.isResizingColumn;
};
